module.exports = __webpack_public_path__ + "img/Thumb_JadeFortune.73c4db95.jpg";